import HydroLogo from './HydroIntelLogo.svg'

export const HydroIntelLogo = HydroLogo
